var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.css.root},[(_vm.box.data.type === 'modal')?_c('BoxModal',{staticStyle:{"margin":"0"},attrs:{"box":Object.assign({}, _vm.box,
      {data: Object.assign({}, _vm.box.data,
        {text: 'Напишите нам'})})}}):(_vm.box.data.id === 'franchise-articles')?_c('FranchiseSlider',{class:_vm.css.slider,attrs:{"article-id":_vm.article.id}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }